export enum PosterItemControlOptions {
  UNGROUP = 'ungroup',
  BACKWARD = 'backward',
  FORWARD = 'forward',
  DUPLICATE = 'duplicate',
  POSITION = 'position',
  COPY_STYLES = 'copy_styles',
  DELETE = 'delete',
}

export enum CopyStyleState {
  COPY = 'copy',
  COPIED = 'copied',
}

export const DEVICE_TYPE = {
  MOBILE: 'mobile',
};
